"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/startSliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type StartSliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Trauma" | "Relationships" | "Anxiety" | "Stress" */
    h10Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeFifteenStartSliderSectionGeneratedProps = {
    divH10H1Props?: Partial<ComponentProps<"h1">> | ((item: StartSliderSectionServicesSlidesItem) => Partial<ComponentProps<"h1">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    startSliderSectionServicesSlides: StartSliderSectionServicesSlidesItem[];
    startSliderSectionServicesSlidesItemWrapper?: (item: StartSliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesH1Visible?: boolean;
    startSliderSectionServicesSlidesH1Renderer?: (item: StartSliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesH1Props?: Partial<ComponentProps<"h1">> | ((item: StartSliderSectionServicesSlidesItem) => Partial<ComponentProps<"h1">>);
};

const HomeFifteenStartSliderSectionGenerated: FC<HomeFifteenStartSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    divH10H1Props,
    startSliderSectionServicesSlides,
    startSliderSectionServicesSlidesItemWrapper,
    startSliderSectionServicesSlidesRenderer,
    startSliderSectionServicesSlidesH1Visible,
    startSliderSectionServicesSlidesH1Renderer,
    startSliderSectionServicesSlidesH1Props,
}) => {
    return (
        <section className="section slider-section-fifteen pt-0 wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-fifteen d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        startSliderSectionServicesSlides,
                        (item: StartSliderSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(startSliderSectionServicesSlidesH1Visible, startSliderSectionServicesSlidesH1Renderer, item, (
                                    <h1 {...(typeof startSliderSectionServicesSlidesH1Props === "function" ? startSliderSectionServicesSlidesH1Props(item) : (startSliderSectionServicesSlidesH1Props ?? {}))} {...(typeof divH10H1Props === "function" ? divH10H1Props(item) : (divH10H1Props ?? {}))}>{item.h10Text}</h1>
                                ))}
                            </div>
                        ),
                        startSliderSectionServicesSlidesItemWrapper,
                        startSliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFifteenStartSliderSectionGenerated;
